module.exports = __webpack_public_path__ + "img/financialResult_3.c21f9f8b.png";